import { createRspackPlugin } from 'unplugin'

import { unpluginFactory } from './unpluginFactory.ts'

export default createRspackPlugin(unpluginFactory)
